import { GetterTree } from "vuex";
import { RootState } from "../types";
import { CandidateState } from "./types";

export const getters: GetterTree<CandidateState, RootState> = {};
